import React, { ChangeEvent, FunctionComponent, useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import logos from '../../media/logos-flag.png';
import worldATitle from '../../media/world-a-title.png';
import worldBTitle from '../../media/world-b-title.png';
import worldCTitle from '../../media/world-c-title.png';
import worldDTitle from '../../media/world-d-title__2.png';
import worldModeOptionsTitle from '../../media/world-mode-options-title.png';
import modeOptionSingle from '../../media/mode-option-single.png';
import modeOptionMultiple from '../../media/mode-option-multiple.png';
import worldMultipleModeDialog from '../../media/world-multiple-mode-dialog.png';
import multipleOptionBack from '../../media/multiple-option-back.png';
import multipleOptionJoin from '../../media/multiple-option-join.png';
import controlArrowLeft from '../../media/control-arrow-left.png';
import GameContext from '../../context/GameContext';
import { auth } from '../../../services/firebase';
import Information from '../../components/common/Information';

export type Worlds = 'cuenca-baja' | 'cuenca-media' | 'cuenca-alta' | 'glaciar';

export interface ModeRouteParams {
    worldId: Worlds;
    groupId: string;
}

interface ModeProps {}

const Mode: FunctionComponent<ModeProps> = () => {
    const history = useHistory();
    const routerParams = useParams<ModeRouteParams>();

    const { handleMainSound } = useContext(GameContext);

    const [isMultipleModeSelected, setIsMultipleModeSelected] = useState(false);
    const [sessionId, setSessionId] = useState('');

    const onSessionIdChange = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();

        setSessionId(event.target.value);
        handleMainSound('play-pop-effect');
    };

    const handleNavigateToLobbyPage = () => {
        history.goBack();
    };

    const handleStartSingleGame = () => {
        history.push(`${process.env.PUBLIC_URL}/intro/${routerParams.worldId}`);
    };

    const handleJoinToGroup = () => {
        history.push(`${process.env.PUBLIC_URL}/group/${routerParams.worldId}/${sessionId}`);
    };

    return (
        <>
            <div className="page-container page-mode animate__animated animate__fadeIn">
                <img
                    src={getWorldTitle(routerParams)}
                    className="world-logo animate__animated animate__backInLeft"
                    alt="¡Bienvenido/a a la Cuenca!"
                />
                <img
                    src={logos}
                    className="common-logos animate__animated animate__slideInDown"
                    alt="Héroes de la Cuenca"
                />
                <div className="mode-dialog-container">
                    {isMultipleModeSelected ? (
                        <>
                            <img
                                src={worldMultipleModeDialog}
                                className="multiple-mode-dialog-message animate__animated animate__flipInX"
                                alt="Ingresa el código de la partida"
                            />
                            <input
                                type="text"
                                value={sessionId}
                                maxLength={4}
                                className="multiple-mode-session-id-input animate__animated animate__zoomIn"
                                onChange={onSessionIdChange}
                            />
                            <div className="mode-dialog-options animate__animated animate__zoomIn">
                                <img
                                    src={multipleOptionBack}
                                    className="mode-dialog-button animate__custom_hover_scale"
                                    alt="Regresar"
                                    onClick={() => setIsMultipleModeSelected(false)}
                                    onMouseEnter={() => handleMainSound('play-pop-effect')}
                                />
                                <img
                                    src={multipleOptionJoin}
                                    className="mode-dialog-button animate__custom_hover_scale"
                                    alt="Unirme"
                                    onMouseEnter={() => handleMainSound('play-pop-effect')}
                                    onClick={handleJoinToGroup}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <img
                                src={worldModeOptionsTitle}
                                className="mode-dialog-message animate__animated animate__flipInX"
                                alt="Elige un modo de juego"
                            />
                            <div className="mode-dialog-options animate__animated animate__zoomIn">
                                <img
                                    src={modeOptionSingle}
                                    className="mode-dialog-button animate__custom_hover_scale"
                                    alt="Modo individual"
                                    onClick={handleStartSingleGame}
                                    onMouseEnter={() => handleMainSound('play-pop-effect')}
                                />
                                {auth.currentUser && (
                                    <img
                                        src={modeOptionMultiple}
                                        className="mode-dialog-button animate__custom_hover_scale"
                                        alt="Modo grupal"
                                        onClick={() => setIsMultipleModeSelected(true)}
                                        onMouseEnter={() => handleMainSound('play-pop-effect')}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </div>
                <img
                    src={controlArrowLeft}
                    className="button-return animate__custom_hover_scale"
                    alt="Regresar"
                    onClick={handleNavigateToLobbyPage}
                    onMouseEnter={() => handleMainSound('play-pop-effect')}
                />
            </div>
            <Information helpText="Haz clic sobre el botón del modo de juego que quieres iniciar, en el individual podrás jugar por tu cuenta y a tu ritmo. En el grupal puedes introducir un código de cuatro números para crear una sesión de varios jugadores simultáneos; o unirte a una sesión ya existente con tus amigo/as." />
        </>
    );
};

export const getWorldTitle = ({ worldId }: ModeRouteParams) => {
    switch (worldId) {
        case 'cuenca-baja':
            return worldATitle;
        case 'cuenca-media':
            return worldBTitle;
        case 'cuenca-alta':
            return worldCTitle;
        case 'glaciar':
            return worldDTitle;
        default:
            return undefined;
    }
};

export default Mode;
